import { render, staticRenderFns } from "./ResetCellPhonePassword.vue?vue&type=template&id=f30d8766&scoped=true"
import script from "./ResetCellPhonePassword.vue?vue&type=script&lang=js"
export * from "./ResetCellPhonePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d8766",
  null
  
)

export default component.exports